import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router, protected http: HttpClient) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ( req.url.indexOf('/api/v1/sessions/me') > -1
      || req.url.indexOf(environment.addressApiEndpoint) > -1
      || req.headers.get('No-Auth') == "True") {

      return next.handle(req.clone());
    }

    let token = sessionStorage.getItem(environment.authTokenStorageKey);

    if (req.url.indexOf('/api/okta/login') > -1) {
       token = sessionStorage.getItem('okta-accesstoken');
    }
    
    if (token != null) {
      const clonedreq = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + token)
      });
      return next.handle(clonedreq).pipe(
        tap({
          error: (err:any) => {
            if (err.status === 401) {
              this.router.navigateByUrl('/login');
            }
          }
        }));
    }
    else {
      this.router.navigateByUrl('/login');
    }

    return null;
  }
}
